module.exports = __webpack_public_path__ + "img/feature-upload-email-hospital.84b88c67.webp";